import React from "react";
import {DownloadItem} from "../types/downloadItem";
import {useTranslation} from "../hooks/useTranslation";

type DownloadsListProps = {
    downloadItem : DownloadItem
}

function DownloadsListItemDownload({downloadItem} : DownloadsListProps) {

    const translate = useTranslation();

    return (
        <div className="downloadsOverview__list--item-download">
            {downloadItem.de &&
                <a className='downloadsOverview__list--item-download-links' href={downloadItem.de} target='_blank'
                   rel="noopener noreferrer">
                    {translate('downloads.lang.link.de')}
                </a>
            }
            {downloadItem.fr &&
                <a className='downloadsOverview__list--item-download-links' href={downloadItem.fr} target='_blank'
                   rel="noopener noreferrer">
                    {translate('downloads.lang.link.fr')}
                </a>
            }
            {downloadItem.en &&
                <a className='downloadsOverview__list--item-download-links' href={downloadItem.en} target='_blank'
                   rel="noopener noreferrer">
                    {translate('downloads.lang.link.en')}
                </a>
            }
            {downloadItem.it &&
                <a className='downloadsOverview__list--item-download-links' href={downloadItem.it} target='_blank'
                   rel="noopener noreferrer">
                    {translate('downloads.lang.link.it')}
                </a>
            }

            {downloadItem.productLink &&
                <a href={downloadItem.productLink}
                   className="downloadsOverview__list--item-download-order d-print-none btn btn--variant-text-icon"
                   target='_blank' rel="noopener noreferrer">{translate('downloads.order.link')}
                </a>
            }
        </div>
    );
}

export default DownloadsListItemDownload;
